module.exports = __webpack_public_path__ + "media/customizations/serenbe/logo-new-21173222a268fa0a80efd9bf04428fcd.png";